import { CustomTable } from "./CustomTable";
import { useEffect, useState } from "react";
import {
  fetchCVApplicationEndPoint,
  subscribeCameraCVApplicationEndPoint,
  updateSmartAlertEndPoint,
} from "../../../configuration";
import { getRandomUUID } from "../../../Token";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/system";
import { Button, ButtonGroup } from "@vds/buttons";
import { styles } from "../../utility/styleUtils";
import { Icon } from "@vds/icons";
import { TextLink } from "@vds/buttons";
import { Link, useLocation } from "react-router-dom";
import { isItGateway } from "../../utility/Utils";
import {
  createSorterForAlertStatus,
  createTableFilterList,
  createTableFilterStaticList,
} from "../../utility/Utils";
import GmtToLocal from "../../utility/GmtToLocal";
import { useDispatch, useSelector } from "react-redux";
import { getCommonAppsTableColumns } from "../../../model/appTableColumns";
import { InlineCheckbox } from "../../utility/styledComponents";
import { setShowSensorActivateModal } from "../../../store/actions";

const AppTable = (props) => {
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const { state } = useLocation();
  const stateData = state.data;
  const {
    appList,
    tableTitle,
    pageName,
    setRefreshDeviceTable,
    setFetchCVApp,
    fetchCVApp,
    handleDelete,
    searchInputText,
    tableLoading,
    buttonAction,
    setSelectedCheckBox,
    onButtonClick,
  } = props;
  const dispatch = useDispatch();
  const [cameraDevices, setCameraDevices] = useState([]);
  const [selectedAlert, setSelectedAlert] = useState(null);
  const [hasToBeRead, setHasToBeRead] = useState(false);
  const [hasToBeClosed, setHasToBeClosed] = useState(false);
  const [filteredInfo, setFilteredInfo] = useState([]);
  const [showTableFilter, setShowTableFilter] = useState(false);
  const [fetchCVApps, setFetchCVApps] = useState(false);
  const navigate = useNavigate();

  const columnMetaDataInfo = {
    showTableFilter,
    filteredInfo,
    appList,
    createSorterForAlertStatus,
    createTableFilterList,
    createTableFilterStaticList,
    GmtToLocal,
  };
  const columnDetails = getCommonAppsTableColumns(columnMetaDataInfo);
  useEffect(() => {
    if (fetchCVApps) {
      console.log("Using updated state:", fetchCVApps);
    }
  }, [fetchCVApps]);
  const handleTableChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
  };

  const handleFilterAction = () => {
    setShowTableFilter(!showTableFilter);
    if (showTableFilter) {
      setFilteredInfo([]);
    }
  };

  const onCheckBoxChange = (e, record) => {
    if (!record.isacknowledged && !record.iscleared) {
      setHasToBeRead(!hasToBeRead);
    }
    if (record.isacknowledged && !record.iscleared) {
      setHasToBeClosed(!hasToBeClosed);
    }
    const selectedRecord = e.target.checked ? record : null;
    if (setSelectedCheckBox) {
      setSelectedCheckBox(selectedRecord);
    }
    setSelectedAlert(selectedRecord);
  };

  const onMarkAsRead = () => updateSelectedAlert({ isacknowledged: true });

  const onCloseAlert = () => updateSelectedAlert({ iscleared: true });
  const updateSelectedAlert = async (payload) => {
    if (selectedAlert) {
      const response = await fetch(updateSmartAlertEndPoint(), {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          ...(activeSession.sessionToken && { Authorization: `Bearer ${activeSession.sessionToken}` }),
          "VZ-M2M-Token": getRandomUUID(),
        },
        body: JSON.stringify({
          accountname: activeSession.accountId,
          resourceidentifier: {
            id: selectedAlert.id,
          },
          smartalert: { ...payload },
        }),
      });
      const updateAlertsRsp = await response.json();
      if (!updateAlertsRsp.error) {
        setFetchCVApp(!fetchCVApp);
      }
    }
  };

  useEffect(() => {
    setSelectedAlert(null);
    setHasToBeClosed(false);
    setHasToBeRead(false);
  }, [fetchCVApp]);

  const renderedColumns = columnDetails.map((item, index) => {
    const {
      title,
      showCheckBox,
      customStyle,
      isLink,
      showMultiColorStatus,
      showMultiColorSeverity,
      navLinks,
      hasInfoLink,
      isDelete,
    } = item;
    return {
      ...item,
      title: () => {
        return (
          <div className="sasp_font-size-14 sas_font-weight-bold">{title}</div>
        );
      },
      render: (text, record) => {
        let linkUrl = isLink ? navLinks.url : "";
        const state = {
          data: record?.device,
          title: `More info for ${record?.device?.name}`,
          fields: record?.device?.fields || {},
        };

        if (hasInfoLink) {
          linkUrl = isItGateway(record.device)
            ? navLinks.gatewayInfo
            : navLinks.sensorInfo;
        }

        const fontWeight =
          showMultiColorSeverity || showMultiColorStatus
            ? "sasp_font-weight-bold"
            : "sasp_font-weight-400";
        const textValue = showMultiColorSeverity
          ? `${text?.charAt(0).toUpperCase()}${text?.slice(1).toLowerCase()}`
          : showMultiColorStatus
          ? record.iscleared
            ? "Closed"
            : record.isacknowledged
            ? "Read"
            : "New"
          : text;
        let textColor =
          showMultiColorSeverity || showMultiColorStatus
            ? `sasp_${textValue.toLowerCase()}-text-color`
            : "";
        {
          !!isDelete && (
            <div
              onClick={() => {
                handleDelete(record);
              }}
            >
              <Icon name="trash" size="medium" color="#000000" />
            </div>
          );
        }
        return {
          children: (
            <div style={{ display: "flex" }}>
              {showCheckBox && (
                <InlineCheckbox
                  onChange={(e) => onCheckBoxChange(e, record)}
                  disabled={
                    record.iscleared ||
                    (selectedAlert && selectedAlert.id !== record.id)
                  }
                  width="auto"
                />
              )}
              {isLink && (
                <TextLink
                  type="standAlone"
                  onClick={() => navigate(linkUrl, { state })}
                  size="large"
                  style={{
                    ...styles.textBoldUnderline,
                    marginLeft: showCheckBox ? 10 : "",
                  }}
                >
                  {textValue}
                </TextLink>
              )}

              {!isLink && (
                <h5
                  style={{ ...customStyle }}
                  className={`sasp_font-size-14 ${fontWeight} ${textColor}`}
                >
                  {textValue}
                </h5>
              )}
              {!!isDelete && (
                <div
                  onClick={() => {
                    handleDelete(record);
                  }}
                >
                  <Icon name="trash" size="medium" color="#000000" />
                </div>
              )}
            </div>
          ),
        };
      },
    };
  });
  const [selectedCvApp, setSelectedCvApp] = useState(null);
  const [cameraSelected, setCameraSelected] = useState(null);
  return (
    <>
      <Box
        sx={{
          p: 2,
          border: "1px solid",
          borderTopLeftRadius: 3,
          borderTopRightRadius: 3,
        }}
      >
        <div className="sasp_d-flex sasp_justify-content-between">
          <div style={styles.hHeader}>{tableTitle}</div>

          <div
            className="sasp_d-flex sasp_justify-content-between sasp_align-items-center"
            style={{ gap: "10px" }}
          >
            {(!pageName || pageName !== "dashboard") && (
              <>
                <div onClick={(e) => setRefreshDeviceTable()}>
                  <Icon name="sync" size="large" color="#000000" />
                </div>
                <div onClick={(e) => handleFilterAction()}>
                  <Icon
                    name="filter"
                    size="large"
                    color={showTableFilter ? "#EE0000" : "#000000"}
                  />
                </div>
              </>
            )}
            {pageName && pageName === "dashboard" && (
              <Button
                variant="text"
                size="small"
                onClick={() => {
                  navigate("/events");
                }}
              >
                View All
              </Button>
            )}
          </div>
        </div>
      </Box>

      <Box
        sx={{
          border: "1px solid",
          borderBottomLeftRadius: 2,
          borderBottomRightRadius: 2,
          borderTopWidth: 0,
        }}
      >
        <CustomTable
          {...props}
          columnDetails={columnDetails}
          dataList={appList}
          searchColumns={[
            "devicename",
            "severity",
            "condition",
            "createdon",
            "contactGroup",
            "alertMessage",
            "alertstatus",
          ]}
          handleChange={handleTableChange}
          tableLoading={tableLoading}
          searchInputText={searchInputText}
          showTableFilter={showTableFilter}
          renderedColumns={renderedColumns}
          filteredInfo={filteredInfo}
          tableName="alerts"
        />
      </Box>
    </>
  );
};

export default AppTable;
